import React from "react";

import AuthUserContext from "./context";
import { currentUser, client } from "../DataNet/DataNetAuth";
import { CircularProgress, Grid } from "@material-ui/core";
import moment from "moment";
import i18n from "../../i18n";
import * as ROUTES from "../../constants/routes";

const signalR = require("@microsoft/signalr");
var _ = require("lodash");

const shouldSkipCurrentUser = () => {
  const pathname = window.location.pathname;
  const a2fInProgress = sessionStorage.getItem("a2fInProgress") === "true";

  return (
    a2fInProgress ||
    pathname === ROUTES.TWO_FACTOR_VERIFY ||
    pathname.startsWith(ROUTES.TWO_FACTOR_VERIFY)
  );
};

const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        authUser: null,
        loaded: false,
        reload: null,
      };
    }

    componentDidMount() {
      if (shouldSkipCurrentUser()) {
        this.setState({ loaded: true });
      } else {
        currentUser().then((authUser) => {
          this.setState({ authUser: authUser, loaded: true });
          !!authUser && i18n.changeLanguage(authUser?.lang);
        });
      }

      let r = setInterval(() => {
        if (shouldSkipCurrentUser()) {
          return;
        }

        currentUser().then((authUser) => {
          !_.isEqual(authUser, this.state.authUser) && this.setState({ authUser: authUser });
        });
      }, 10000);

      this.setState({
        reload: r,
      });

      /*client.onmessage = (message) => {
        console.log("datos recividos", message.data);
        //let authUser = message.data === "" ? null : JSON.parse(message.data);
        //console.log(authUser);
        this.setState({ authUser: JSON.parse(message.data).authUser });
      };*/

      /**
       * enviar
       */
      //this.setState({ authUser: null });
      /*this.listener = this.props.firebase.auth.onAuthStateChanged(
        (authUser) => {
          authUser
            ? this.setState({ authUser })
            : this.setState({ authUser: null });
        }
      );*/
    }

    componentWillUnmount() {
      clearInterval(this.state.reload);
    }

    render() {
      //console.log("valor", this.state.authUser);
      return (
        <AuthUserContext.Provider value={this.state.authUser}>
          <Component {...this.props} />
        </AuthUserContext.Provider>
      );
    }
  }

  return WithAuthentication;
};

export default withAuthentication;
